// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Button,
//   Typography,
//   FormControlLabel,
//   Checkbox,
//   Alert,
//   Box,
// } from "@mui/material";
// import { CheckRounded } from "@mui/icons-material";
// import {
//   MESSAGES,
//   textSecondary,
//   buttonGradient,
//   buttonGradientHover,
//   buttonShadow,
// } from "../../../constants/consts";

// const TITLE_MAX = 100; // ✅ Konu karakter limiti
// const DESCRIPTION_MAX = 2000; // ✅ Açıklama limiti (isteğe bağlı)

// export default function AddSupportDialog({
//   open,
//   onClose,
//   onSubmit,
//   requireContractApproval = false,
// }) {
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [approved, setApproved] = useState(false);
//   const [error, setError] = useState("");
//   const [submitting, setSubmitting] = useState(false);

//   useEffect(() => {
//     if (open) {
//       setTitle("");
//       setDescription("");
//       setApproved(false);
//       setError("");
//       setSubmitting(false);
//     }
//   }, [open]);

//   const handleSubmit = async () => {
//     const t = title.trim();
//     const d = description.trim();

//     if (!t) {
//       setError(MESSAGES.SUPPORT_VALIDATION_TITLE);
//       return;
//     }
//     if (t.length > TITLE_MAX) {
//       setError(
//         MESSAGES.SUPPORT_VALIDATION_TITLE_MAX ||
//           `Konu en fazla ${TITLE_MAX} karakter olabilir.`,
//       );
//       return;
//     }
//     if (requireContractApproval && !approved) {
//       setError(MESSAGES.SUPPORT_VALIDATION_CONTRACT);
//       return;
//     }

//     setSubmitting(true);
//     setError("");
//     try {
//       await onSubmit(t, d);
//       onClose();
//     } catch (err) {
//       setError(err?.response?.data?.message || MESSAGES.SUPPORT_CREATE_ERROR);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
//       <DialogTitle fontWeight={700}>
//         {MESSAGES.SUPPORT_NEW_DIALOG_TITLE}
//       </DialogTitle>
//       <DialogContent>
//         <Typography variant="body2" color={textSecondary} sx={{ mb: 2 }}>
//           {MESSAGES.SUPPORT_NEW_DIALOG_DESC}
//         </Typography>

//         {error && (
//           <Alert severity="warning" sx={{ mb: 2, borderRadius: 2 }}>
//             {error}
//           </Alert>
//         )}

//         {/* Konu — kısa, max 100 karakter */}
//         <TextField
//           fullWidth
//           label={MESSAGES.SUPPORT_NEW_TITLE_LABEL}
//           placeholder={MESSAGES.SUPPORT_NEW_TITLE_HINT}
//           value={title}
//           onChange={(e) => setTitle(e.target.value.slice(0, TITLE_MAX))}
//           disabled={submitting}
//           inputProps={{ maxLength: TITLE_MAX }}
//           helperText={`${title.length}/${TITLE_MAX}`}
//           FormHelperTextProps={{ sx: { textAlign: "right", mr: 0 } }}
//           sx={{ mb: 2 }}
//         />

//         {/* Açıklama — opsiyonel, uzun olabilir */}
//         <TextField
//           fullWidth
//           label={MESSAGES.SUPPORT_NEW_DESC_LABEL || "Açıklama (opsiyonel)"}
//           placeholder={
//             MESSAGES.SUPPORT_NEW_DESC_HINT ||
//             "Talebinizi detaylı bir şekilde açıklayın..."
//           }
//           value={description}
//           onChange={(e) =>
//             setDescription(e.target.value.slice(0, DESCRIPTION_MAX))
//           }
//           multiline
//           minRows={4}
//           maxRows={10}
//           disabled={submitting}
//           inputProps={{ maxLength: DESCRIPTION_MAX }}
//           helperText={`${description.length}/${DESCRIPTION_MAX}`}
//           FormHelperTextProps={{ sx: { textAlign: "right", mr: 0 } }}
//         />

//         {requireContractApproval && (
//           <Box sx={{ mt: 2 }}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={approved}
//                   onChange={(e) => setApproved(e.target.checked)}
//                   disabled={submitting}
//                   size="small"
//                 />
//               }
//               label={
//                 <Typography variant="body2">
//                   {MESSAGES.SUPPORT_CONTRACT_CHECK}
//                 </Typography>
//               }
//             />
//           </Box>
//         )}
//       </DialogContent>

//       <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//         <Button
//           onClick={onClose}
//           disabled={submitting}
//           variant="outlined"
//           sx={{ textTransform: "none", borderRadius: 2 }}
//         >
//           {MESSAGES.SUPPORT_DIALOG_CLOSE}
//         </Button>
//         <Button
//           onClick={handleSubmit}
//           disabled={submitting}
//           variant="contained"
//           startIcon={<CheckRounded />}
//           sx={{
//             textTransform: "none",
//             borderRadius: 2,
//             fontWeight: 600,
//             background: buttonGradient,
//             boxShadow: buttonShadow,
//             "&:hover": {
//               background: buttonGradientHover,
//             },
//           }}
//         >
//           {MESSAGES.SUPPORT_DIALOG_SAVE}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  Alert,
  Box,
} from "@mui/material";
import { CheckRounded, AddRounded } from "@mui/icons-material";
import { keyframes } from "@mui/system";
import {
  MESSAGES,
  textSecondary,
  buttonGradient,
  buttonGradientHover,
  buttonShadow,
} from "../../../constants/consts";

const TITLE_MAX = 100;
const DESCRIPTION_MAX = 2000;

// --- Animasyonlar ---
const popIn = keyframes`
  from { opacity: 0; transform: scale(0.85); }
  to   { opacity: 1; transform: scale(1); }
`;
const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export default function AddSupportDialog({
  open,
  onClose,
  onSubmit,
  requireContractApproval = false,
}) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [approved, setApproved] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setTitle("");
      setDescription("");
      setApproved(false);
      setError("");
      setSubmitting(false);
    }
  }, [open]);

  const handleSubmit = async () => {
    const t = title.trim();
    const d = description.trim();

    if (!t) {
      setError(MESSAGES.SUPPORT_VALIDATION_TITLE);
      return;
    }
    if (t.length > TITLE_MAX) {
      setError(
        MESSAGES.SUPPORT_VALIDATION_TITLE_MAX ||
          `Konu en fazla ${TITLE_MAX} karakter olabilir.`,
      );
      return;
    }
    if (requireContractApproval && !approved) {
      setError(MESSAGES.SUPPORT_VALIDATION_CONTRACT);
      return;
    }

    setSubmitting(true);
    setError("");
    try {
      await onSubmit(t, d);
      onClose();
    } catch (err) {
      setError(err?.response?.data?.message || MESSAGES.SUPPORT_CREATE_ERROR);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      TransitionProps={{ timeout: 250 }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          animation: open
            ? `${popIn} 0.28s cubic-bezier(0.22, 1, 0.36, 1) both`
            : "none",
        },
      }}
    >
      <DialogTitle
        fontWeight={700}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: "50%",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #045781 0%, #A5AF67 100%)",
            color: "#fff",
            flexShrink: 0,
            animation: open
              ? `${popIn} 0.35s cubic-bezier(0.22, 1, 0.36, 1) 0.05s backwards`
              : "none",
          }}
        >
          <AddRounded sx={{ fontSize: 20 }} />
        </Box>
        {MESSAGES.SUPPORT_NEW_DIALOG_TITLE}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" color={textSecondary} sx={{ mb: 2 }}>
          {MESSAGES.SUPPORT_NEW_DIALOG_DESC}
        </Typography>

        {error && (
          <Alert
            severity="warning"
            sx={{
              mb: 2,
              borderRadius: 2,
              animation: `${fadeInUp} 0.3s ease-out both`,
            }}
          >
            {error}
          </Alert>
        )}

        {/* Konu */}
        <Box
          sx={{
            animation: open
              ? `${fadeInUp} 0.35s ease-out 0.05s backwards`
              : "none",
          }}
        >
          <TextField
            fullWidth
            label={MESSAGES.SUPPORT_NEW_TITLE_LABEL}
            placeholder={MESSAGES.SUPPORT_NEW_TITLE_HINT}
            value={title}
            onChange={(e) => setTitle(e.target.value.slice(0, TITLE_MAX))}
            disabled={submitting}
            inputProps={{ maxLength: TITLE_MAX }}
            helperText={`${title.length}/${TITLE_MAX}`}
            FormHelperTextProps={{ sx: { textAlign: "right", mr: 0 } }}
          />
        </Box>

        {/* Açıklama */}
        <Box
          sx={{
            mt: 2,
            animation: open
              ? `${fadeInUp} 0.35s ease-out 0.12s backwards`
              : "none",
          }}
        >
          <TextField
            fullWidth
            label={MESSAGES.SUPPORT_NEW_DESC_LABEL || "Açıklama (opsiyonel)"}
            placeholder={
              MESSAGES.SUPPORT_NEW_DESC_HINT ||
              "Talebinizi detaylı bir şekilde açıklayın..."
            }
            value={description}
            onChange={(e) =>
              setDescription(e.target.value.slice(0, DESCRIPTION_MAX))
            }
            multiline
            minRows={4}
            maxRows={10}
            disabled={submitting}
            inputProps={{ maxLength: DESCRIPTION_MAX }}
            helperText={`${description.length}/${DESCRIPTION_MAX}`}
            FormHelperTextProps={{ sx: { textAlign: "right", mr: 0 } }}
          />
        </Box>

        {requireContractApproval && (
          <Box
            sx={{
              mt: 2,
              animation: open
                ? `${fadeInUp} 0.35s ease-out 0.18s backwards`
                : "none",
            }}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={approved}
                  onChange={(e) => setApproved(e.target.checked)}
                  disabled={submitting}
                  size="small"
                />
              }
              label={
                <Typography variant="body2">
                  {MESSAGES.SUPPORT_CONTRACT_CHECK}
                </Typography>
              }
            />
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          disabled={submitting}
          variant="outlined"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            transition: "transform 0.2s ease, background-color 0.2s ease",
            "&:hover": { transform: "translateY(-1px)" },
            "&:active": { transform: "translateY(0) scale(0.98)" },
          }}
        >
          {MESSAGES.SUPPORT_DIALOG_CLOSE}
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={submitting}
          variant="contained"
          startIcon={submitting ? null : <CheckRounded />}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 600,
            background: buttonGradient,
            boxShadow: buttonShadow,
            transition:
              "transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease",
            "&:hover": {
              background: buttonGradientHover,
              transform: "translateY(-1px)",
              boxShadow: "0 8px 20px rgba(4,87,129,0.35)",
            },
            "&:active": { transform: "translateY(0) scale(0.98)" },
          }}
        >
          {submitting ? (
            <Box
              sx={{
                width: 18,
                height: 18,
                border: "2px solid rgba(255,255,255,0.4)",
                borderTopColor: "#fff",
                borderRadius: "50%",
                animation: "spin 0.8s linear infinite",
                "@keyframes spin": {
                  to: { transform: "rotate(360deg)" },
                },
              }}
            />
          ) : (
            MESSAGES.SUPPORT_DIALOG_SAVE
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
